
define('text!modules/form/form_template.html',[],function () { return '  <div class="form-body">\r\n\r\n  </div>\r\n';});

